import { render, staticRenderFns } from "./OpenBoxFx.vue?vue&type=template&id=49bf026c&scoped=true"
import script from "./OpenBoxFx.vue?vue&type=script&lang=js"
export * from "./OpenBoxFx.vue?vue&type=script&lang=js"
import style0 from "./OpenBoxFx.vue?vue&type=style&index=0&id=49bf026c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bf026c",
  null
  
)

export default component.exports